import { Point, AlignmentSettings } from '../../types/pattern';

interface DrawOrientationCenterProps {
  ctx: CanvasRenderingContext2D;
  position: Point;
  settings: AlignmentSettings;
}

export const drawOrientationCenter = ({ ctx, position, settings }: DrawOrientationCenterProps) => {
  if (!settings.showGuides) return;
  
  ctx.save();
  ctx.translate(position.x, position.y);
  
  // Draw thin crosshair
  ctx.strokeStyle = '#666';
  ctx.lineWidth = 1;
  
  // Vertical line
  ctx.beginPath();
  ctx.moveTo(0, -10);
  ctx.lineTo(0, 10);
  ctx.stroke();
  
  // Horizontal line
  ctx.beginPath();
  ctx.moveTo(-10, 0);
  ctx.lineTo(10, 0);
  ctx.stroke();
  
  // Center dot
  ctx.beginPath();
  ctx.arc(0, 0, 2, 0, Math.PI * 2);
  ctx.fillStyle = '#666';
  ctx.fill();
  
  ctx.restore();
}; 